<div *ngIf="!this.loading" class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">Payments</h1>
          <p class="text-sm text-primary-500">
            View all of Your Payments Received
          </p>
        </div>
        <div class="flex gap-2">
          <p-button
            icon="pi pi-download"
            label="Export"
            severity="secondary"></p-button>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
      <p-table
        #dt2
        dataKey="id"
        stripedRows
        [value]="filtered_payments"
        responsiveLayout="scroll"
        [paginator]="true"
        [scrollable]="true"
        [resizableColumns]="true"
        [autoLayout]="true"
        [rows]="25"
        selectionMode="single"
        [(selection)]="selectedPayment"
        [globalFilterFields]="['customer_id.name', 'payment_status']"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #emptymessage>
          <tr>
            <td colspan="6">No payments found.</td>
          </tr>
        </ng-template>

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pResizableColumn pSortableColumn="customer_id.name">
              Customer
              <p-sortIcon field="customer_id.name" />
            </th>
            <th pSortableColumn="payment_date">
              Date
              <p-sortIcon field="payment_date" />
            </th>
            <th pResizableColumn pSortableColumn="payment_status">
              Status
              <p-sortIcon field="payment_status" />
            </th>
            <th pResizableColumn pSortableColumn="payment_total">
              Amount
              <p-sortIcon field="payment_total" />
            </th>
            <th></th>
          </tr>
          <tr>
            <th>
              <p-columnFilter
                type="text"
                field="customer_id.name"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter type="date" field="createdAt"></p-columnFilter>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="payment_status"></p-columnFilter>
            </th>
            <th></th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td>
              <a
              *ngIf="rowData.customer_id?.id"
              [routerLink]="['/admin/customers/view', rowData.customer_id?.id]"
              class="text-blue-600 hover:underline">
              {{rowData.customer_id?.name}}
            </a>
            <span *ngIf="!rowData.id">
              {{rowData.customer_id?.name}}
            </span>
            </td>
            <td>
              {{ rowData.payment_date * 1000 | date }}
            </td>
            <td>
              <span [ngClass]="rowData.payment_status === 'succeeded' ? 'green' : 'red'">
                {{ rowData.payment_status }}
              </span>
            </td>
            <td style="text-align: right">
              {{ rowData.payment_total | currency : "USD" }}
            </td>
            <td>
              <p-button
                (click)="activeItem = rowData; menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    </div>
  </block-ui>
</div>
<div *ngIf="this.loading" class="p-8 text-center">
  <p class="text-gray-500">Loading customer data...</p>
</div>
